<template>
  <v-row no-gutters class="container" elevation="0">
    <v-row no-gutters class="content">
      <div class="primary-action-container" v-if="$slots['primary-action']">
        <slot name="primary-action" />
      </div>

      <div class="icon-container" v-if="$slots['custom-icon']">
        <slot name="custom-icon" />
      </div>

      <div no-gutters class="icon-container" v-if="iconName">
        <v-icon class="icon" size="16">{{ iconName }}</v-icon>
      </div>

      <v-row no-gutters class="content-primary-texts">
        <span
          v-if="title"
          :class="
            titleCustomClass
              ? titleCustomClass
              : 'body-regular-small neutral-20-dark--text'
          "
        >
          {{ title }}
        </span>

        <span
          v-if="subtitle"
          :class="
            subtitleCustomClass
              ? subtitleCustomClass
              : 'body-regular-smaller neutral-40-light--text'
          "
        >
          {{ subtitle }}
        </span>

        <div @click="linkRedirect">
          <a
            target="_blank"
            type="secondary"
            v-if="link && linkRedirect"
            :class="
              linkCustomClass
                ? linkCustomClass
                : 'body-bold-smaller neutral-30-base--text'
            "
          >
            {{ link }}

            <v-icon class="body-bold-small" size="12">mdi-open-in-new</v-icon>
          </a>
        </div>
      </v-row>
    </v-row>

    <v-row
      no-gutters
      class="secondary-action-container"
      v-if="$slots['secondary-action']"
    >
      <slot name="secondary-action" />
    </v-row>
  </v-row>
</template>

<script>
export default {
  name: 'BaseActionList',
  props: {
    title: {
      type: String,
      default: '',
      required: false,
    },
    titleCustomClass: {
      type: String,
      default: '',
      required: false,
    },
    subtitle: {
      type: String,
      default: '',
      required: false,
    },
    subtitleCustomClass: {
      type: String,
      default: '',
      required: false,
    },
    link: {
      type: String,
      default: '',
      required: false,
    },
    linkRedirect: {
      type: Function,
      default: () => {},
      required: false,
    },
    linkCustomClass: {
      type: String,
      default: '',
      required: false,
    },
    iconName: {
      type: String,
      default: '',
      required: false,
    },
  },
  methods: {},
  computed: {},
}
</script>

<style lang="scss" scoped>
.container {
  justify-content: space-between;
  text-transform: unset;
  background-color: varFigma(neutral-100-white) !important;
  padding: 8px;
  gap: 16px;
  &.v-row::before {
    background-color: inherit !important;
  }
  &:hover {
    background-color: varFigma(neutral-99) !important;
  }
}

.content {
  gap: 16px;
}

.icon {
  color: varFigma(neutral-20-dark);
}

.content-primary-texts {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: start;
}

.primary-action-container {
  justify-content: flex-start;
  align-items: center;
}

.secondary-action-container {
  justify-content: flex-end;
  align-items: center;
}

.icon-container {
  display: flex;
  background-color: transparent;
  align-items: center;
  justify-content: center;
}
</style>
